export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      
    },
    {
      name: 'Settings',
      url: '/settings/page',
      icon: 'icon-settings',
    },
	{
      name: 'Academic',
      url: '/academic/page',
      icon: 'fa fa-home',
	},
	{
	  name: 'Staff',
      url: '/staff/page',
      icon: 'icon-people',
	},
	{
      name: 'Student',
      url: '/student/dashboard',
      icon: 'icon-user',
    },
	/*{
	  name: 'Accounts',
      url: 'https://stjosephschool.kalvisalai.in/accounts/#/auto-login',
      icon: 'fa fa-money'
	}, */
	/*{
      name: 'Transport',
      url: '/transport/page',
      icon: 'fa fa-truck',
    },
	{
      name: 'Hostel',
      url: '/hostel/page',
      icon: 'fa fa-building',
    },*/
	{
	  name: 'SMS',
      url: '/message/page',
      icon: 'icon-speech',
    },
	{
      name: 'App / Web Content',
      url: '/app/page',
      icon: 'fa fa-mobile',
	},
	{
	  name: 'Manage',
      url: '/manage/page',
      icon: 'fa fa-list',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js